module.exports = __webpack_public_path__ + "img/4.654ccbf7.jpg";